const piiValueFindingsPanel = {
  typeLabels: {
    kennitala: "Kennitala",
    email: "Email address",
    phone: "Phone (+354)",
    ktCue: "Possible kennitala (near 'kt.')",
  },
  header: "⚠ Possible PII found inside unmarked cells ({{count}})",
  allDecisionsMade: "All decisions made — {{count}} will be pseudonymized",
  pendingDecision: "{{count}} still need a decision",
  instructions: {
    intro:
      "For each finding below, decide what should happen to the highlighted substring:",
    hashLabel: "Pseudonymize",
    hashDescription:
      "replaces the suspected identifier value with a pseudonym.",
    dismissLabel: "Dismiss",
    dismissDescription: "false positive, leave as is.",
    columnIntro:
      "Or handle the entire column at once with one of these column-level actions:",
    pseudonymizeLabel: "Pseudonymize the whole column",
    pseudonymizeDescription:
      "every cell in the column is replaced with a single pseudonym of the cell's full content.",
    dropLabel: "Drop this column",
    dropDescription: "removes the column from the upload entirely.",
  },
  findingCount_one: "{{count}} finding",
  findingCount_other: "{{count}} findings",
  columnDroppedNotice:
    "✗ this column will be removed from the upload — per-value decisions ignored",
  columnPseudonymizedNotice:
    "✓ every cell in this column will be replaced with a single pseudonym of the full cell — per-value decisions ignored",
  restoreColumn: "Restore column",
  restoreColumnTitle: "Restore this column to the upload",
  hashAllMatchedValues: "Pseudonymize all matched values",
  hashAllMatchedValuesTitle:
    "For every finding in this column, replace just the matched substring with a pseudonym. Surrounding free text in each cell stays as-is.",
  dismissAll: "Dismiss all",
  dismissAllTitle: "Mark every finding in this column as a false positive",
  pseudonymizeColumn: "Pseudonymize the whole column",
  pseudonymizeColumnTitle:
    "Replace every cell in this column with a pseudonym of the cell's full content (not just the matched substrings). Per-value decisions in this column are then ignored.",
  dropColumn: "Drop this column",
  dropColumnTitle:
    "Remove this column from the upload entirely. The data service will never receive it. Faster than cancelling, re-exporting without the column, and re-uploading.",
  table: {
    row: "Row",
    type: "Type",
    context: "Context",
    action: "What should happen to the highlighted value?",
  },
  willBeHashed: "Will be pseudonymized: {{value}}",
  dismissedNotice: "Dismissed — value will be kept as-is",
  hashThisValue: "Pseudonymize",
  hashThisValueTitle:
    "Replace just this substring with a pseudonym (rest of cell preserved)",
  dismiss: "Dismiss",
  dismissTitle: "False positive — leave the cell unchanged",
  acknowledge:
    "I have reviewed every finding above and confirm the file is safe to upload as configured.",
  pendingWarning_one:
    "{{count}} finding still needs a decision — pick “Pseudonymize”, “Dismiss”, or pseudonymize the column.",
  pendingWarning_other:
    "{{count}} findings still need a decision — pick “Pseudonymize”, “Dismiss”, or pseudonymize the column.",
  redactSummary_one: "{{count}} value will be pseudonymized in place before upload.",
  redactSummary_other:
    "{{count}} values will be pseudonymized in place before upload.",
};

export default piiValueFindingsPanel;
